import axios from 'axios';
import { baseUrl } from '../App';

/**
 * Performs a logout operation by making a POST request to the server
 * @param {string} lastToken - The authentication token of the current user session
 * @returns {Promise<Object>} The response from the server after logout
 * @throws {Error} If the logout request fails
 */
const logoutOperationApi = async (lastToken) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/logout/`,
      { empty: '' },
      { headers: { Authorization: `Token ${lastToken}` } }
    );
    console.log(response);
    return response;
  } catch (error) {
    console.error('Logout failed:', error);
    throw error;
  }
};

export { logoutOperationApi };
